import React from "react";
import ChantButton from "../../../../../CommonComponents/ChantButton/ChantButton";

const inputStyle = {
  width: "100px",
  padding: "4px 8px",
  fontSize: "14px",
  border: "1px solid #d9d9d9",
  borderRadius: "6px",
  outline: "none",
};

const subLabelStyle = {
  fontSize: "12px",
  color: "#595959",
  display: "block",
  marginBottom: "4px",
};

const ChildPriceInput = ({
  childPrice,
  onChildPriceChange,
  onRemove,
  editChanges,
}) => {
  const handleAmountChange = (e) => {
    let editChangesUpdated = editChanges;
    editChangesUpdated.childProductId = childPrice.childProductId;
    let value = e.target.value;
    if (Number(value) >= 0) {
      editChangesUpdated.childPriceChange = true;
      if (value.includes(".") && value.length - value.indexOf(".") > 2) {
        value = value.slice(0, value.indexOf(".") + 3);
      }
      onChildPriceChange({ ...childPrice, amount: Number(value) }, editChangesUpdated);
    }
  };

  const handleShippingChange = (e) => {
    let editChangesUpdated = editChanges;
    editChangesUpdated.childProductId = childPrice.childProductId;
    let value = e.target.value;
    if (Number(value) >= 0) {
      editChangesUpdated.childPriceChange = true;
      if (value.includes(".") && value.length - value.indexOf(".") > 2) {
        value = value.slice(0, value.indexOf(".") + 3);
      }
      onChildPriceChange({ ...childPrice, shipping: Number(value) }, editChangesUpdated);
    }
  };

  return (
    <div style={{ marginBottom: "24px", paddingLeft: "16px", borderLeft: "3px solid #e8e8e8" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
        <label style={{ marginBottom: 0, fontWeight: 500 }}>Price Per Child</label>
        <ChantButton type="secondary" onClick={onRemove}>Remove</ChantButton>
      </div>
      <p style={{ fontSize: 13, color: "#595959", marginBottom: "12px" }}>
        Child package does not allow Chant access. Only child&apos;s name is collected. A member number is assigned. Details are stored with parent account.
      </p>
      <div style={{ display: "flex", gap: "20px", alignItems: "flex-end", flexWrap: "wrap" }}>
        <div>
          <span style={subLabelStyle}>Amount ($)</span>
          <input
            type="number"
            min={0}
            onChange={handleAmountChange}
            value={childPrice.amount}
            className="no-arrow-field"
            style={inputStyle}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        <div>
          <span style={subLabelStyle}>Price Type</span>
          <input
            value="Per child"
            disabled
            style={{ ...inputStyle, background: "#f5f5f5", color: "#8c8c8c", width: "120px" }}
          />
        </div>
        <div>
          <span style={subLabelStyle}>Shipping ($)</span>
          <input
            type="number"
            onChange={handleShippingChange}
            value={childPrice.shipping}
            className="no-arrow-field"
            style={inputStyle}
            onWheel={(e) => e.target.blur()}
          />
        </div>
      </div>
    </div>
  );
};

export default ChildPriceInput;
